import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { PageContext, Redirector4SaleConfig } from 'src/app/service/redirector.service'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { ContactformComponent } from 'src/app/elements/contactform/contactform.component'
import { ContentBlockComponent } from 'src/app/elements/content-block/content-block.component'
import { NgClass } from '@angular/common';
import { PriceComponent } from 'src/app/elements/price/price.component'
import { TaxNoteComponent } from 'src/app/elements/tax-note/tax-note.component'
import { SafePipe } from 'src/app/pipes/safe.pipe'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { RouterLink } from '@angular/router'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'

@Component({
  selector: 'app-forsale-default',
  templateUrl: './forsale-default.component.html',
  styleUrl: './forsale-default.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconComponent,
    ContactformComponent,
    ContentBlockComponent,
    NgClass,
    PriceComponent,
    TaxNoteComponent,
    SafePipe,
    I18nSelectorComponent,
    RouterLink,
    UserTokenPipe
],
})
export class ForsaleDefaultComponent {
  @Input() context!: PageContext<Redirector4SaleConfig>

  constructor () {}
}
